import { createFileRoute } from '@tanstack/react-router';
import { MinhaContaPage } from '@/components/conta';

export const Route = createFileRoute('/_app/conta')({
  component: MinhaContaPage,
});
